import format from 'date-fns/format/index.js'
import { commonSearchOptions, commonSearchProjects } from '@/api/common/search'
import { RechargeType } from '@/common/permission'
import { ref, computed } from 'vue'
import { getChannelById } from '@com/utils/channel'
import { testList } from '@/views/producer/common-template/selling-strategy.js'
import _ from 'lodash'
import { formatDollar } from '@pt/views/dashboard/unit'

const searchOptions = ref<any[]>([])
const searchProjects = ref<any[]>([])

export const _default = {
  adv_id: undefined,
  adv_ids: [],
  keyword: '',
  project_ids: [],
  basic_ids: [],
  time: [],
  stop_time: [],
  status: [],
  is_test: undefined,
  page: 1,
  page_size: 15,
  search_field: 'project_id',
}

export const formItemList = computed(() => {
  return [
    {
      type: 'input',
      prop: 'adv_id',
      subtype: 'text',
      params: {
        clearable: true,
        placeholder: '广告主id',
      },
    },
    {
      prop: 'adv_ids',
      type: 'business',
      subtype: 'advertiser-selector',
      params: {
        multiple: true,
        filterable: true,
        clearable: true,
        style: 'width: 220px;',
        placeholder: '请选择广告主',
      },
    },
    {
      type: 'input',
      prop: 'keyword',
      subtype: 'text',
      params: {
        clearable: true,
        placeholder: '项目id',
      },
    },
    {
      type: 'select',
      prop: 'project_ids',
      params: {
        multiple: true,
        placeholder: '项目名称',
        filterable: true,
        'collapse-tags': true,
        remote: true,
        clearable: true,
        remoteMethod: (query: string) => {
          return getSearchProjects(query)
        },
        options: searchProjects.value,
      },
    },
    {
      type: 'select',
      prop: 'basic_ids',
      params: {
        multiple: true,
        placeholder: '创意ID及名称',
        filterable: true,
        'collapse-tags': true,
        remote: true,
        clearable: true,
        remoteMethod: (query: string) => {
          return getSearchOptions(query)
        },
        options: searchOptions.value,
      },
    },
    {
      type: 'select',
      prop: 'status',
      params: {
        multiple: true,
        placeholder: '计费状态',
        clearable: true,
        options: [
          { label: '计费中', value: '1' },
          { label: '计费结束', value: '2,3' },
        ],
      },
    },
    {
      type: 'select',
      prop: 'is_test',
      params: {
        placeholder: '是否测试账号',
        clearable: true,
        options: testList,
      },
    },
    {
      type: 'date-picker',
      subtype: 'daterange',
      prop: 'time',
      class: 'date-picker',
      params: {
        clearable: true,
        startPlaceholder: '素材推送开始时间',
        endPlaceholder: '素材推送结束时间',
        // pickerOptions: {
        //   disabledDate(time: any) {
        //     return time.getTime() > Date.now()
        //   },
        // },
      },
    },
    {
      type: 'date-picker',
      subtype: 'daterange',
      prop: 'stop_time',
      class: 'date-picker',
      params: {
        clearable: true,
        startPlaceholder: '停止计费开始日期',
        endPlaceholder: '停止计费结束日期',
      },
    },
  ]
})

export const _tableColumnConfig = [
  {
    label: '广告主ID',
    prop: 'adv_id',
  },
  {
    label: '广告主名称',
    prop: 'adv_name',
  },
  {
    label: '项目ID',
    prop: 'project_id',
  },
  {
    label: '项目名称',
    prop: 'project_name',
  },
  {
    label: '创意ID',
    prop: 'basic_id',
  },
  {
    label: '创意名称',
    prop: 'mws_creative_name',
  },
  {
    label: '推送渠道',
    prop: 'traffic_type',
    params: {
      innerHTML: ({ row }) => {
        if (!row.traffic_type) return '全部'
        const channel = getChannelById(row.traffic_type)

        return channel?.label ?? '-'
      },
    },
  },
  {
    label: '计费状态',
    prop: 'status',
    params: {
      innerHTML: ({ row }) => {
        let text = '-'
        switch (row.status) {
          case 1:
            text = '计费中'
            break
          case 3:
          case 2:
            text = '计费结束'
            break
          default:
            text = '-'
        }
        return text
      },
    },
  },
  {
    label: '开始计费日期',
    prop: 'created_time',
    width: 110,
    params: {
      innerHTML: ({ row }) => {
        return format(row.created_time * 1000, 'YYYY-MM-DD')
      },
    },
  },
  {
    label: '停止计费日期',
    prop: 'stop_time',
    params: {
      innerHTML: ({ row }) => {
        if (row.stop_time) {
          const stopTime = String(row.stop_time)
          return `${stopTime.slice(0, 4)}-${stopTime.slice(
            4,
            6,
          )}-${stopTime.slice(6)}`
        }
        return '-'
      },
    },
  },
  {
    label: '广告展示数',
    prop: 'impression',
    dataFormat: {
      type: 'number', // string，可选 number/text/percentage/currency/permillage
      thousandsSeparator: true, // boolean，是否要千位分隔符
    },
  },
  {
    label: '广告点击数',
    prop: 'click',
    dataFormat: {
      type: 'number', // string，可选 number/text/percentage/currency/permillage
      thousandsSeparator: true, // boolean，是否要千位分隔符
    },
  },
  {
    label: '广告安装数',
    prop: 'install',
    dataFormat: {
      type: 'number', // string，可选 number/text/percentage/currency/permillage
      thousandsSeparator: true, // boolean，是否要千位分隔符
    },
  },
  {
    label: '计费方式',
    prop: 'consume_type',
    params: {
      innerHTML: ({ row }) => {
        if (row.consume_type === RechargeType.cost) {
          return 'SpendShare'
        } else if (row.consume_type === RechargeType.cpm) {
          return 'CPM'
        }
        return row.consume_type
      },
    },
  },
  {
    label: '单价',
    prop: 'unit_price',
    params: {
      innerHTML: ({ row }) => {
        return row.consume_type === RechargeType.cpm
          ? formatDollar(row.unit_price)
          : row.unit_price + '%'
      },
    },
  },
  {
    label: '计费数量',
    prop: 'quantity',
  },
  {
    label: '素材消耗费用',
    prop: 'total_service_fee',
    params: {
      innerHTML: ({ row }) => {
        return formatDollar(row.total_service_fee)
      },
    },
  },
  {
    label: '素材总费用',
    prop: 'total_amount',
    params: {
      innerHTML: ({ row }) => {
        return formatDollar(row.total_amount)
      },
    },
  },
  {
    label: '渠道cap',
    prop: 'channel_max_price',
    params: {
      innerHTML({ row }) {
        if (row.channel_max_price > 0) {
          return formatDollar(row.channel_max_price)
        }
        return '-'
      },
    },
  },
  {
    label: '全渠道cap',
    prop: 'creative_max_price',
    params: {
      innerHTML({ row }) {
        if (row.creative_max_price > 0) {
          return formatDollar(row.creative_max_price)
        }
        return '-'
      },
    },
  },
  {
    label: '渠道buyout',
    prop: 'channel_buyout_price',
    params: {
      innerHTML({ row }) {
        if (row.channel_buyout_price > 0) {
          return formatDollar(row.channel_buyout_price)
        }
        return '-'
      },
    },
  },
  {
    label: '全渠道buyout',
    prop: 'creative_buyout_price',
    params: {
      innerHTML({ row }) {
        if (row.creative_buyout_price > 0) {
          return formatDollar(row.creative_buyout_price)
        }
        return '-'
      },
    },
  },
]

export async function getSearchOptions(name: string) {
  if (!name) return
  const res = await commonSearchOptions({
    keyword: name,
    search_field: 'mws_creative_name',
    type: 'billing',
  })
  searchOptions.value = (_.get(res, 'data.data.list') || []).map(
    (item: any) => ({
      ...item,
      label: item.name,
    }),
  )
}

export async function getSearchProjects(name: string) {
  if (!name) return
  const res = await commonSearchProjects({
    keyword: name,
  })
  searchProjects.value = (_.get(res, 'data.data.list') || []).map(
    (item: any) => ({
      ...item,
      value: item.id,
      label: item.name,
    }),
  )
}
